var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLeague = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/League"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.97852 2.09941C4.67821 2.09941 4.43477 2.34285 4.43477 2.64316C4.43477 2.94346 4.67821 3.18691 4.97852 3.18691H6.04809V9.84665H4.97852C4.67821 9.84665 4.43477 10.0901 4.43477 10.3904C4.43477 10.6907 4.67821 10.9342 4.97852 10.9342H6.59185C6.89215 10.9342 7.1356 10.6907 7.1356 10.3904V7.06053H7.92901C8.22932 7.06053 8.47276 6.81708 8.47276 6.51678C8.47276 6.21647 8.22932 5.97303 7.92901 5.97303H7.1356V2.64316C7.1356 2.34285 6.89215 2.09941 6.59185 2.09941H4.97852Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.70361 4.95431C8.70361 4.5401 9.0394 4.20432 9.45361 4.20432H11.6706C12.0848 4.20432 12.4206 4.5401 12.4206 4.95432V8.02315C12.4206 8.43736 12.0848 8.77315 11.6706 8.77315H9.45361C9.0394 8.77315 8.70361 8.43736 8.70361 8.02315V4.95431ZM9.79111 5.29181V7.68565H11.3331V5.29181H9.79111Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.419922 1.42981C0.419922 1.0156 0.755708 0.67981 1.16992 0.67981H3.38694C3.80116 0.67981 4.13694 1.0156 4.13694 1.42981V4.49864C4.13694 4.91286 3.80116 5.24864 3.38694 5.24864H1.16992C0.755709 5.24864 0.419922 4.91286 0.419922 4.49864V1.42981ZM1.50742 1.76731V4.16114H3.04944V1.76731H1.50742Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.419922 8.72198C0.419922 8.30777 0.755708 7.97198 1.16992 7.97198H3.38694C3.80116 7.97198 4.13694 8.30777 4.13694 8.72198V11.7908C4.13694 12.205 3.80116 12.5408 3.38694 12.5408H1.16992C0.755709 12.5408 0.419922 12.205 0.419922 11.7908V8.72198ZM1.50742 9.05948V11.4533H3.04944V9.05948H1.50742Z",
    fill: "#E0E0E0"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLeague);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/League.aee5df32d1c5b146b77b778060cf5525.svg";